import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class CVfUtilsService {

	constructor() {
		// 
	}

	/**
	 * Remove the /-/ || /- for the [{index}] in the jsonPath
	 * @param path 
	 * @param indexs 
	 */
	transformAJSFPath(path: string, dataIndex: any): string {
		const pattern = /\/-\/?/gm;
		const testPath = path.indexOf('/') > -1 ? path.replace('/', '') : path;
		const matches = testPath.match(pattern);

		let i = 0;
		const nPath = testPath.replace(
			pattern,
			(match: any, offset: string | number): any => {
				const replace = dataIndex[i];
				const replaceText = [`[${replace}]`];
				i++;

				// offset:        numeric position of match
				// match.length : numeric value of the match length (/-/ || /-) => 3 || 2
				// 1:             to point the inmediate next character to the match
				if (path[offset + match.length + 1] !== undefined) {
					replaceText.push('.');
				}

				if (replace !== null && replace !== undefined) {
					return replaceText.join('');
				}
				return match;
			});

		return nPath.split('/').join('.');
	}

	/**
	 * Remove the [] for the [{index}] in the jsonPath
	 * @param path 
	 * @param indexs 
	 */
	transformJSONPath(path: string, dataIndex: any): string {
		const pattern = /\[\]/gm;
		const testPath = path.indexOf('/') > -1 ? path.replace('/', '') : path;
		const matches = testPath.match(pattern);

		let i = 0;
		const nPath = testPath.replace(
			pattern,
			(match: any, offset: string | number): any => {
				const replace = dataIndex[i];
				const replaceText = [`[${replace}]`];
				i++;

				if (replace !== null && replace !== undefined) {
					return replaceText.join('');
				}
				return match;
			});
		return nPath.split('/').join('.');
	}

	/**
	 * Given an JSONpath, return the dataIndex Array
	 * @param jsonPath 
	 * @returns 
	 */
	transformDATAPath(jsonPath: string): Array<any> {
		const pattern = /\[(\d+)\]/gm;
		const matches = jsonPath.match(pattern) || [];
		const dataIndex = [];

		matches.forEach(value => {
			dataIndex.push(value.replace('[', '').replace(']', ''));
		});

		return dataIndex;
	}

	/**
	 * Transverse the document to get the match parent Tag Name
	 * @param element
	 * @param tagName
	 */
	getParentByTagName(element: any, tagName: string): any {
		if (element && element.tagName === tagName) {
			return element;
		} else if (!element) {
			// Nothing was found
			return null;
		}
		// Not found, go for it
		return this.getParentByTagName(element.parentNode, tagName);
	}

	/**
	 * Select parent from the Event Key
	 * 
	 * @param items
	 * @param eventKey
	 */
	getSmartTagItem(items: any[], eventKey: string, eventValue?: string): any {
		for (let itemIndex = 0; itemIndex <= items.length; itemIndex++) {
			const currentElement = items[itemIndex];
			if (currentElement) {
				if (currentElement.key === eventKey || (eventValue && currentElement.value === eventValue)) {
					if (!currentElement.pathTo && !currentElement.viewMode) {
						// It is a Subcategory
						return { subCategory: currentElement };
					} else {
						// A root element
						return { smartTagType: currentElement, subCategory: currentElement };
					}
				}
				if (items[itemIndex].children) {
					const childSelected = this.getSmartTagItem(currentElement.children, eventKey, eventValue);
					if (childSelected) {
						if (!childSelected.smartTagType) {
							return Object.assign(childSelected, { smartTagType: currentElement });
						} else {
							return Object.assign(childSelected, { rootParent: currentElement });
						}
					}
				}
			}
		}
		return null;
	}

	/**
	 * Get from the selected Smart Tag the possible View Mode if Available
	 * @param selectedSmartTagItem
	 */
	public getSelectedViewMode(selectedSmartTagItem: any): any {
		let viewMode = null;

		if (selectedSmartTagItem) {
			// Review Root Level
			if (selectedSmartTagItem.rootParent && selectedSmartTagItem.rootParent.viewMode) {
				viewMode = selectedSmartTagItem.rootParent.viewMode;
			}
			// Second Level
			if (selectedSmartTagItem.smartTagType && selectedSmartTagItem.smartTagType.viewMode) {
				viewMode = selectedSmartTagItem.smartTagType.viewMode;
			}
			// Last Level (Last Child)
			if (selectedSmartTagItem.subCategory && selectedSmartTagItem.subCategory.viewMode) {
				viewMode = selectedSmartTagItem.subCategory.viewMode;
			}
		}

		return viewMode;
	}

	/**
	 * Get from the selected Smart Tag the possible Form Controls if available
	 * @param selectedSmartTagItem
	 */
	public getSelectedFormControls(selectedSmartTagItem: any): any {
		if (selectedSmartTagItem) {
			// Review Root Level
			if (selectedSmartTagItem.rootParent && selectedSmartTagItem.rootParent.formControl) {
				return selectedSmartTagItem.rootParent.formControl;
			} else // Second Level
			if (selectedSmartTagItem.smartTagType && selectedSmartTagItem.smartTagType.formControl) {
				return selectedSmartTagItem.smartTagType.formControl;
			} else // Last Level (Last Child)
			if (selectedSmartTagItem.subCategory && selectedSmartTagItem.subCategory.formControl) {
				return selectedSmartTagItem.subCategory.formControl;
			}
		}
		return null;
	}
}
